module.exports = __webpack_public_path__ + "img/small-1.d9271b60.jpg";